import React from 'react';
import { MenuProduct } from '../../../../XV2';
import { UiDialog, UiGrid } from '@open-stack/ui';
import { XCard } from '../../../x/card/XCard';
import styled from 'styled-components';
import { XButtonBottom } from '../../../x/button/bottom/XButtonBottom';
import { MenuProductCardIcon } from '../../../menu/product/card/icon/MenuProductCardIcon';
import { XText, XTextType } from '../../../x/text/XText';

const Wrapper = styled(UiGrid)`
    .image-container {
        display: flex;
        align-items: center;
        justify-content: center;

        .isLarge {
            height: 16rem;
            width: 16rem;
        }
    }
`;

interface Props {
    menuProduct: MenuProduct;

    onClose(): void;
}

export function MenuProductCardDetails({ menuProduct, onClose }: Props) {
    const { name, description, icon } = menuProduct.product;

    return (
        <>
            <UiDialog isOpen onClose={onClose}>
                <Wrapper gap={1}>
                    <XCard padding={2}>
                        <UiGrid>
                            <div className="image-container">
                                <MenuProductCardIcon icon={icon} />
                            </div>

                            <XText type={XTextType.TITLE}>{name}</XText>

                            <XText>{description}</XText>
                        </UiGrid>
                    </XCard>

                    <XButtonBottom onClick={onClose} hasPlaceholder color="surface">
                        Close
                    </XButtonBottom>
                </Wrapper>
            </UiDialog>
        </>
    );
}
